import { render, staticRenderFns } from "./Alter.vue?vue&type=template&id=42cb7c05&scoped=true&"
import script from "./Alter.vue?vue&type=script&lang=js&"
export * from "./Alter.vue?vue&type=script&lang=js&"
import style0 from "./Alter.vue?vue&type=style&index=0&id=42cb7c05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb7c05",
  null
  
)

export default component.exports